export default __webpack_public_path__ + "static/media/flag-ca-ES.ccf40382.png";